import { render, staticRenderFns } from "./programmes.vue?vue&type=template&id=c333c04a&scoped=true&"
import script from "./programmes.vue?vue&type=script&lang=js&"
export * from "./programmes.vue?vue&type=script&lang=js&"
import style0 from "./programmes.vue?vue&type=style&index=0&id=c333c04a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c333c04a",
  null
  
)

export default component.exports